import {planTypes} from "@/common/constants";

export default {
  data() {
    return {
      title: this.$t('billing.pbx.plan_name.ZPA'),
      subtitle: '',
      planType: planTypes.ZOOM_PHONE$ZPA,
      description: this.$t('billing.pbx.plan_desc.ZPA'),
    }
  }
};
